import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getAll(params: any = {}) {
  const response = await http
    .getDataParam("/supervisi-laundry", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/supervisi-laundry/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/supervisi-laundry", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/supervisi-laundry/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/supervisi-laundry/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/supervisi-laundry/${id}/pdf`, "_blank");
}

export default {
  getAll,
  find,
  create,
  update,
  destroy,
  printPdf,
};
